import { defineMessages } from 'react-intl';
const messages = defineMessages({
  color: {
    id: 'color',
    defaultMessage: 'Kolorea',
  },
});
export const buttonStyleSchemaEnhancer = (props) => {
  const { schema, intl } = props;
  schema.properties.styles.schema.fieldsets[0].fields = [
    ...schema.properties.styles.schema.fieldsets[0].fields,
    'button-color',
  ];

  schema.properties.styles.schema.properties['button-color'] = {
    title: intl.formatMessage(messages.color),
    widget: 'select',
    default: 'primary',
    choices: [
      ['primary', 'Primary color'],
      ['white', 'White'],
    ],
  };
  // schema.properties.styles.schema.properties[
  //   '--button-background-color'
  // ].actions = ['#92c35d', 'white'];
  return schema;
};
